import { useMe } from '@features/user-profile/hooks/useMe';

export interface TierInfo {
  tier: 'core' | 'pro' | null;
  isPro: boolean;
}

/**
 * The caller's subscription tier, read from `/me` — NEVER the OIDC token, which carries no billing
 * claims. `subscription == null` means the billing feature is dark (BE `Stripe:Enabled` is false) or
 * `/me` predates the field; both fail OPEN as `{ tier: null, isPro: true }` — the BE gate is the real
 * enforcement, so the nav lock / upsells must not block a feature the server would allow through.
 *
 * Deliberately does not re-derive from `isEntitled`/`status` (that's `SubscriptionGuard`'s job for
 * the all-or-nothing app gate) — this is purely "which tier's features should render," so a lapsed
 * Pro subscriber still sees Pro-gated UI right up until the guard itself blocks the app.
 */
export function useTier(): TierInfo {
  const me = useMe();
  const subscription = me.data?.subscription;
  if (subscription == null) return { tier: null, isPro: true };
  return { tier: subscription.tier, isPro: subscription.tier === 'pro' };
}
